






















































































import Vue from 'vue';

export default Vue.extend({
  name: 'Preloader',
  props: {
    fullScreen: {
      type: Boolean,
      default: false,
    },
    size: {
      type: [Number, String],
      default: 200,
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
  },
});
